import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { JobMiniEntity } from '../../domain/entities/JobMiniEntity'
import type { JobAdminListedDtoAdmin } from '@/backend/market'

export class JobMiniModel extends JobMiniEntity {
  constructor(dataDto: JobAdminListedDtoAdmin) {
    super()
    mapEntityProperties<JobMiniModel>(this, dataDto)
  }
}
